(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-main"]) return;
  try {
    
  if (!customElements.get('forse-product-gallery')) {
    class ForseProductGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-index]'));
        this.counter = this.querySelector('[data-gallery-counter]');
        this.currentIndex = 0;

        this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => {
          this.show((this.currentIndex - 1 + this.slides.length) % this.slides.length);
        });

        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
          this.show((this.currentIndex + 1) % this.slides.length);
        });

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.show(Number(thumb.dataset.galleryIndex)));
        });
      }

      show(index) {
        if (!this.slides[index]) return;
        this.currentIndex = index;

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });

        this.thumbs.forEach((thumb, thumbIndex) => {
          const isActive = thumbIndex === index;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-selected', String(isActive));
        });

        if (this.counter) {
          const current = String(index + 1).padStart(2, '0');
          const total = String(this.slides.length).padStart(2, '0');
          this.counter.textContent = `${current} / ${total}`;
        }
      }
    }

    customElements.define('forse-product-gallery', ForseProductGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
